import { render, staticRenderFns } from "./PluginCookieBot.vue?vue&type=template&id=3fad25e5"
import script from "./PluginCookieBot.vue?vue&type=script&lang=js"
export * from "./PluginCookieBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fad25e5')) {
      api.createRecord('3fad25e5', component.options)
    } else {
      api.reload('3fad25e5', component.options)
    }
    module.hot.accept("./PluginCookieBot.vue?vue&type=template&id=3fad25e5", function () {
      api.rerender('3fad25e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginCookieBot.vue"
export default component.exports